// extracted by mini-css-extract-plugin
export default {"container":"FactorsRisk_container__ydYLm","item":"FactorsRisk_item__GBvIz","imgBox":"FactorsRisk_imgBox__5-lm5","containerTitle":"FactorsRisk_containerTitle__7mrw5"};